export default __webpack_public_path__ + "static/media/NDL_41.4c74cc72.png";